import { SPage } from 'servisofts-component2';
import root from './root';
import question from './question';
import fotos from './fotos';
export default SPage.combinePages("checklist", {
    "": root,
    "question": question,
    "fotos": fotos,
});